<template>
  <a-layout class="role-manage">
    <a-layout-sider width="280" style="background: #fff;padding:16px 0 16px 16px">
      <left-tree />
    </a-layout-sider>
    <a-layout-content style="background: #fff;padding: 16px">
      <div class="content">
        <right-tree />
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import leftTree from './modules/leftTree.vue'
import rightTree from './modules/rightTree.vue'
export default {
  components: {
    leftTree,
    rightTree
  }
}
</script>

<style>

</style>
